import { render, staticRenderFns } from "./UnAttributesView.vue?vue&type=template&id=361b1c20&lang=pug&"
import script from "./UnAttributesView.vue?vue&type=script&lang=js&"
export * from "./UnAttributesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports